// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StreamCapAd__wrapper--2YsCU"};